import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BusinessCentralSyncCompletedEvent } from '../models/business-central/business-central-sync-completed-event.interface';
import { BaseHub } from './base.hub';

export const BUSINESS_CENTRAL_SYNC_COMPLETED_EVENT =
  'businessCentralSyncCompleted';

@Injectable({
  providedIn: 'root',
})
export class BusinessCentralSyncHub extends BaseHub {
  private readonly syncCompletedSubject$ =
    new Subject<BusinessCentralSyncCompletedEvent>();

  public readonly businessCentralSyncCompleted$: Observable<BusinessCentralSyncCompletedEvent> =
    this.syncCompletedSubject$.asObservable();

  constructor() {
    super(`${environment.baseUrl}/hubs/business-central-sync`);
  }

  /**
   * Wires the businessCentralSyncCompleted server-to-client handler. Called by
   * BaseHub.startConnection AFTER the connection is built but BEFORE .start()
   * is invoked, so events that land during the start handshake are delivered
   * to syncCompletedSubject$ instead of being silently dropped.
   */
  protected override registerHandlers(): void {
    this.hubConnection.on(
      BUSINESS_CENTRAL_SYNC_COMPLETED_EVENT,
      (event: BusinessCentralSyncCompletedEvent) => {
        this.syncCompletedSubject$.next(event);
      },
    );
  }
}
